<template>
  <section class="main">
    <div class="col-12 d-md-block d-none">
      <h3 class="subtitle">Informações</h3>
      <hr class="simple" />
    </div>
    <br/>
    <div class="col-12">
        <b-alert show variant="info">
      
          Para solicitar alterações dos dados cadastrais
            <b-button @click="buscarChamadosFluig" variant="info" 
              class="m-1"
              :disabled="isLockedBtnConsultar" 
              :style="{ backgroundColor: isLockedBtnConsultar ? '#ebeef5' : '', color: isLockedBtnConsultar ?  '#495057' : '#ffffff'}"
              >
            Clique aqui
          </b-button>
            para verificar se existe solicitação em andamento.
           
          
                               
          <p class="mb-4"></p>


        </b-alert>
    </div>


    <div class="col-12" v-if="this.atendimento">
        <b-alert show variant="info">
          <p class="mb-4">
            Para alteração do nome fantasia ou razão social, gentileza entrar em contato pelos outros canais de <a href="https://www.cdlbh.com.br/atendimento/" title="atendimento" target="_blank"><u>atendimento</u>  </a>
          </p>
        </b-alert>
    </div>

    <div>
      <div class="col-12">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="info"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p class="mb-4"></p>
            
            <p class="d-flex justify-content-center mb-4">Verificando se os dados estão atualizados, favor aguardar {{ dismissCountDown }} segundos...</p>  
            
            <div class="d-flex justify-content-center mb-3">
              <b-spinner style="width: 2rem; height: 2rem;" label="Large Spinner" type="grow"></b-spinner>
            </div>
            <p class="mb-4"></p>
          </b-alert>
      </div>
      <div class="col-12">
          <div class="form-group">
                    <div
                      class="alert alert-danger border-0 text-center"
                      v-if="campoObrigatorio"
                      role="alert"
                    >
                      {{
                          "Os campos não foram modificados!"
                      }}
                    </div>
          </div>
      </div>
      <div class="col-12" v-if="asChamadosCadastrais">
        
          <b-alert show variant="light">
            <p class="mb-4"></p>
             <h3 class="alert-heading"> <span :style="{ color: '#000000' }">Status de alteração</span></h3>
             <br/>
                      <p class="mb-4"></p>
                      <div>
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th>Chamado</th>
                              <th>Data de Abertura</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>

                            <tr v-for="item in todosChamadosAbertos" :key="item.codigo" :class="{'table-success': item.dataFechamento !== '','table-warning': item.dataFechamento === ''}">
                              <td> {{ item.codigo }}</td>
                              <td> {{ item.dataAbertura }}</td>
                              <td v-if="item.dataFechamento !== ''">{{ "Concluído" }}</td>
                              <td v-if="item.dataFechamento === ''">{{ "Em andamento" }}</td>
                            </tr>

                          </tbody>
                        </table>
                    </div>
        </b-alert>
      </div>
    </div>


    <div v-if="formularioExibir">
   
    <div class="row py-4">
      <div class="col">
        <ul class="nav nav-tabs" id="dados-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="home-tab"
              data-toggle="tab"
              href
              role="tab"
              aria-controls="home"
              aria-selected="true"
              @click="activeData = 0"
              :disabled="isLocked" 
              :style="{ backgroundColor: isLocked ? '#ebeef5' : '#05438e'}"
              >Dados da Empresa</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="profile-tab"
              data-toggle="tab"
              href
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              @click="activeData = 1"
              :disabled="isLocked" 
              :style="{ backgroundColor: isLocked ? '#ebeef5' : '#05438e' }"
              >Dados de Contato</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="contact-tab"
              data-toggle="tab"
              href
              role="tab"
              aria-controls="contact"
              aria-selected="false"
              @click="activeData = 2"
              :style="{ backgroundColor: isLocked ? '#ebeef5' : '#05438e' }"
              >Endereços</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Dados Principais -->
    <form class="form_padrao pt-2" v-if="activeData == 0" id="dados-principais" @keydown.tab.prevent>
 
      <div class="form-row">
        <div class="form-group flutuante col-md-3">
          <input
            type="text"
            name="doc"
            id="doc"
            v-model="usuario.dadosCadastraisAssociado[0].doc"
            :disabled="true" :style="{ backgroundColor: '#ebeef5' }"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            @keyup="setDados('doc', usuario.dadosCadastraisAssociado[0].doc)"
            required
          />
          <label for="doc">CPF/CNPJ</label>
        </div>
        <div class="form-group flutuante col-md-6">
          <input
            type="text"
            name="razaosocial"
            id="razaosocial"
            v-model="usuario.dadosCadastraisAssociado[0].razaosocial"
            :disabled="true" :style="{ backgroundColor: '#ebeef5' }"
            @keyup="setDados('razaosocial', usuario.dadosCadastraisAssociado[0].razaosocial)"
            required/>
          <label for="razaosocial">Razão Social</label>
        </div>
        <div class="form-group flutuante col-md-3">
          <input
            type="text"
            name="nomecomercial"
            id="nomecomercial"
            required
            :disabled="true" :style="{ backgroundColor: '#ebeef5' }"
            v-model="usuario.dadosCadastraisAssociado[0].nomecomercial"
            @keyup="setDados('nomecomercial', usuario.dadosCadastraisAssociado[0].nomecomercial)"
          />
          <label for="nomecomercial">Nome Comercial</label>
        
        </div>

      </div>
      <div class="form-row">
        <div class="form-group flutuante col-md-6">
          <input
            type="text"
            name="emailDadosPrincipais"
            id="emailDadosPrincipais"
            v-model="usuario.dadosCadastraisAssociado[0].email"
            @keyup="setDados('emailDadosPrincipais', usuario.dadosCadastraisAssociado[0].email)"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
          />
          <label for="emailDadosPrincipais">E-mail</label>
        </div>
        <div class="form-group flutuante col-md-3">
          <input
            type="text"
            name="telefoneDadosCadastrais"
            id="telefoneDadosCadastrais"
            v-model="usuario.dadosCadastraisAssociado[0].telefone"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
            v-mask="['########', '#########']"
            @keyup="setDados('telefoneDadosCadastrais', usuario.dadosCadastraisAssociado[0].telefone)"
          />
          <label for="telefoneDadosCadastrais">Telefone</label>
        </div>
        <div class="form-group flutuante col-md-3">
                      <input
                        type="text"
                        name="inscest"
                        id="inscest"
                        v-model="usuario.dadosCadastraisAssociado[0].inscest"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        v-bind:maxlength="9"
                        @keyup="setDados('inscest', usuario.dadosCadastraisAssociado[0].inscest)"
                      />
                      <label for="inscest">Inscrição Estadual</label>
        </div>
      </div>
      <div
          class="form-group col-12 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="button"
            class="btn btn-verde p-0 fit-content"
            @click="solicitarAlteracao"
            :disabled="isLockedBtnSolicitar" 
            :style="{ 'backgroundColor': isLockedBtnSalvar ? '#ebeef5' : '', 'border-color' : isLockedBtnSalvar ? '#ebeef5' : '#00a04e'}"
          >
            <span>Solicitar</span>
          </button>
        </div>


    </form>

    <!-- Dados de Contato -->
    <form class="form_padrao pt-2" v-if="activeData == 1" @keydown.tab.prevent>
      <div class="form-row">
        <div class="form-group flutuante col-md-3">
          <input
            type="text"
            name="dadosContatoCPF"
            id="dadosContatoCPF"
            v-model="usuario.dadosContatoPrincipal[0].cpf"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
            v-mask="['###.###.###-##']"
            @keyup="
              setDadosContato('dadosContatoCPF', usuario.dadosContatoPrincipal[0].cpf)
            "
          />
          <label for="dadosContatoCPF">CPF</label>
        </div>
        <div class="form-group flutuante col-md-4">
          <input
            type="text"
            name="nomeContato"
            id="nomeContato"
            v-model="usuario.dadosContatoPrincipal[0].nome"
            @keyup="setDadosContato('nomeContato', usuario.dadosContatoPrincipal[0].nome)"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
          />
          <label for="nomeContato">Nome do Contato</label>
        </div>

        <div class="form-group flutuante col-md-4">
          <input
            type="text"
            name="emailContato"
            id="emailContato"
            v-model="usuario.dadosContatoPrincipal[0].email"
            @keyup="setDadosContato('emailContato', usuario.dadosContatoPrincipal[0].email)"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
          />
          <label for="emailContato">E-mail</label>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group flutuante col-md-2" >
          <input
            type="text"
            name="ddd"
            id="ddd"
            v-model="usuario.dadosContatoPrincipal[0].ddd"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
            v-mask="['##']"
            @keyup="setDadosContato('ddd', usuario.dadosContatoPrincipal[0].ddd)"
          />
          <label for="ddd">DDD</label>
        </div>
        <div class="form-group flutuante col-md-3">
          <input
            type="text"
            name="telefone"
            id="telefone"
            v-model="usuario.dadosContatoPrincipal[0].telefone"
            :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
            required
            v-mask="['####-####', '#####-####']"
            @keyup="setDadosContato('telefone', usuario.dadosContatoPrincipal[0].telefone)"
          />
          <label for="telefone">Telefone</label>
        </div>
        <div
          class="form-group col-12 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="button"
            class="btn btn-verde p-0 fit-content"
            @click="solicitarAlteracao"
            :style="{ 'backgroundColor': isLockedBtnSalvar ? '#ebeef5' : '', 'border-color' : isLockedBtnSalvar ? '#ebeef5' : '#00a04e'}"
          >
            <span>Solicitar</span>
          </button>
        </div>
      </div>
    </form>

    <!-- Endereço Dados da Empresa / Dados de Cobrança e Correspondencia -->
    <form class="form_padrao pt-2" v-if="activeData == 2" id="dados-cobranca" @keydown.tab.prevent>
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">Endereço de Cobrança</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
              <div class="form-row">
                <div class="form-group flutuante col-md-3">
                  <input
                    type="text"
                    name="cepCobranca"
                    id="cepCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].cep"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="searchCepCobranca()"
                    @click="setDadosCobranca('cepCobranca', usuario.dadosEnderecoCobranca[0].cep)"
                    placeholder="digite o cep aqui"
                    v-bind:maxlength="9"
                    v-mask="['#####-###']"
                    required
                  />
                  <label for="cepCobranca">Cep</label>
                </div>
                <div class="form-group flutuante col-md-6">
                  <input
                    type="text"
                    name="logradouroCobranca"
                    id="logradouroCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].lograd"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="setDadosCobranca('logradouroCobranca',usuario.dadosEnderecoCobranca[0].lograd)"
                    required
                  />
                  <label for="logradouroCobranca">Endereço</label>
                </div>
                <div class="form-group flutuante col-md-3">
                  <input
                    type="text"
                    name="numeroCobranca"
                    id="numeroCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].numero"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="setDadosCobranca('numeroCobranca', usuario.dadosEnderecoCobranca[0].numero)"
                    required
                  />
                  <label for="numeroCobranca">Número</label>
                </div>
                <div class="form-group flutuante col-md-4">
                  <input
                    type="text"
                    name="complementoCobranca"
                    id="complementoCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].complemento"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="setDadosCobranca('complementoCobranca', usuario.dadosEnderecoCobranca[0].complemento)"
                    required
                  />
                  <label for="complementoCobranca">Complemento</label>
                </div>
                <div class="form-group flutuante col-md-4">
                  <input
                    type="text"
                    name="cidadeCobranca"
                    id="cidadeCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].cidade"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="setDadosCobranca('numeroCobranca', usuario.dadosEnderecoCobranca[0].cidade)"
                    required
                  />
                  <label for="cidadeCobranca">Cidade</label>
                </div>
                <div class="form-group flutuante col-md-4">
                  <input
                    type="text"
                    name="ufCobranca"
                    id="ufCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].uf"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="setDadosCobranca('ufCobranca', usuario.dadosEnderecoCobranca[0].uf)"
                    required
                  />
                  <label for="ufCobranca">UF</label>
                </div>
                <div class="form-group flutuante col-md-4">
                  <input
                    type="text"
                    name="bairroCobranca"
                    id="bairroCobranca"
                    v-model="usuario.dadosEnderecoCobranca[0].bairro"
                    :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                    @keyup="setDadosCobranca('bairroCobranca', usuario.dadosEnderecoCobranca[0].bairro)"
                    required
                  />
                  <label for="bairroCobranca">Bairro</label>
                </div>
              </div>
              <div class="form-group col-12 d-flex flex-row justify-content-end align-items-end">
                  <button
                    type="button"
                    class="btn btn-verde p-0 fit-content"
                    @click="solicitarAlteracao"
                    :style="{ 'backgroundColor': isLockedBtnSalvar ? '#ebeef5' : '', 'border-color' : isLockedBtnSalvar ? '#ebeef5' : '#00a04e'}"
                  >
                    <span>Solicitar</span>
                  </button>
            </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 variant="info">Endereço da Empresa</b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                  <div class="form-row">

                    <div class="form-group flutuante col-md-2">
                      <input
                        type="text"
                        name="cepDadosPrincipais"
                        id="cepDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].cep"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        @keyup="searchCepDadosPrincipais()"
                        @click="setDados('cepDadosPrincipais', usuario.dadosCadastraisAssociado[0].cep)"
                        placeholder="digite o cep aqui"
                        v-bind:maxlength="9"
                        required
                      />
                      <label for="cepDadosPrincipais">CEP</label>
                    </div>
                    <div class="form-group flutuante col-md-6">
                      <input
                        type="text"
                        name="logradouroDadosPrincipais"
                        id="logradouroDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].lograd"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"  
                        @keyup="setDados('logradouroDadosPrincipais', usuario.dadosCadastraisAssociado[0].lograd)"
                        required
                      />
                      <label for="logradouroDadosPrincipais">Endereço</label>
                    </div>
                    <div class="form-group flutuante col-md-2">
                      <input
                        type="text"
                        name="numeroDadosPrincipais"
                        id="numeroDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].numero"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        @keyup="setDados('numeroDadosPrincipais', usuario.dadosCadastraisAssociado[0].numero)"
                        required
                      />
                      <label for="numeroDadosPrincipais">Número</label>
                    </div>
                    <div class="form-group flutuante col-md-2">
                      <input
                        type="text"
                        name="ufDadosPrincipais"
                        id="ufDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].uf"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        @keyup="setDados('ufDadosPrincipais', usuario.dadosCadastraisAssociado[0].uf)"
                        required
                      />
                      <label for="ufDadosPrincipais">UF</label>
                    </div>
                    <div class="form-group flutuante col-md-8">
                      <input
                        type="text"
                        name="complementoDadosPrincipais"
                        id="complementoDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].complemento"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        @keyup="setDados('complementoDadosPrincipais', usuario.dadosCadastraisAssociado[0].complemento)"
                        required
                      />
                      <label for="complementoDadosPrincipais">Complemento (opcional)</label>
                    </div>
                    <div class="form-group flutuante col-md-4">
                      <input
                        type="text"
                        name="bairroDadosPrincipais"
                        id="bairroDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].bairro"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        @keyup="setDados('bairroDadosPrincipais', usuario.dadosCadastraisAssociado[0].bairro)"
                        required
                      />
                      <label for="bairroDadosPrincipais">Bairro</label>
                    </div>
                    <div class="form-group flutuante col-md-4">
                      <input
                        type="text"
                        name="cidadeDadosPrincipais"
                        id="cidadeDadosPrincipais"
                        v-model="usuario.dadosCadastraisAssociado[0].cidade"
                        :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                        @keyup="setDados('cidadeDadosPrincipais', usuario.dadosCadastraisAssociado[0].cidade)"
                        required
                      />
                      <label for="cidadeDadosPrincipais">Cidade</label>
                    </div> 

                    <div
                      class="form-group col-12 d-flex flex-row justify-content-end align-items-end"
                    >
                      <button
                        type="button"
                        class="btn btn-verde p-0 fit-content"
                        @click="solicitarAlteracao"
                        :disabled="isLockedBtnSalvar" 
                        :style="{ 'backgroundColor': isLockedBtnSalvar ? '#ebeef5' : '', 'border-color' : isLockedBtnSalvar ? '#ebeef5' : '#00a04e'}"
                        
                      >
                        <span>Solicitar</span>
                      </button>
                    </div>
                  </div>


              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-3 variant="info">Endereço de Correspondência</b-button>
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
          <div class="form-row">
            <div class="form-group flutuante col-md-3">
              <input
                type="text"
                name="cepCorrespondencia"
                id="cepCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].cep"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="searchCepCorrespondencia()"
                @click="setDadosCorrespondencia('cepCorrespondencia', usuario.dadosEnderecoCorrespondencia[0].cep)"
                placeholder="digite o cep aqui" 
                v-bind:maxlength="9"
                v-mask="['#####-###']"
                required
              />          
              <label for="cepCorrespondencia">CEP</label>
            </div>
            
            <div class="form-group flutuante col-md-6">
              <input
                type="text"
                name="logradouroCorrespondencia"
                id="logradouroCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].lograd"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="
                  setDadosCorrespondencia(
                    'logradouroCorrespondencia',
                    usuario.dadosEnderecoCorrespondencia[0].lograd
                  )
                "
                required
              />
              <label for="logradouroCorrespondencia">Endereço</label>
            </div>
            <div class="form-group flutuante col-md-3">
              <input
                type="text"
                name="numeroCorrespondencia"
                id="numeroCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].numero"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="
                  setDadosCorrespondencia(
                    'numeroCorrespondencia',
                    usuario.dadosEnderecoCorrespondencia[0].numero
                  )
                "
                required
              />
              <label for="numeroCorrespondencia">Número</label>
            </div>
            <div class="form-group flutuante col-md-4">
              <input
                type="text"
                name="complementoCorrespondencia"
                id="complementoCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].complemento"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="
                  setDadosCorrespondencia(
                    'complementoCorrespondencia',
                    usuario.dadosEnderecoCorrespondencia[0].complemento
                  )
                "
                required
              />
              <label for="complementoCorrespondencia">Complemento</label>
            </div>
            <div class="form-group flutuante col-md-4">
              <input
                type="text"
                name="cidadeCorrespondencia"
                id="cidadeCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].cidade"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="
                  setDadosCorrespondencia(
                    'cidadeCorrespondencia',
                    usuario.dadosEnderecoCorrespondencia[0].cidade
                  )
                "
                required
              />
              <label for="cidadeCorrespondencia">Cidade</label>
            </div>
            <div class="form-group flutuante col-md-4">
              <input
                type="text"
                name="ufCorrespondencia"
                id="ufCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].uf"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="setDadosCorrespondencia('ufCorrespondencia', usuario.dadosEnderecoCorrespondencia[0].uf)"
                required
              />
              <label for="ufCorrespondencia">UF</label>
            </div>
            <div class="form-group flutuante col-md-4">
              <input
                type="text"
                name="bairroCorrespondencia"
                id="bairroCorrespondencia"
                v-model="usuario.dadosEnderecoCorrespondencia[0].bairro"
                :disabled="isLocked" :style="{ backgroundColor: isLocked ? '#ebeef5' : ''}"
                @keyup="setDadosCorrespondencia('bairroCorrespondencia', usuario.dadosEnderecoCorrespondencia[0].bairro)"
                required
              />
              <label for="bairroCorrespondencia">Bairro</label>
            </div>
          </div>
          <div
          class="form-group col-12 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="button"
            class="btn btn-verde p-0 fit-content"
            @click="solicitarAlteracao"
            :style="{ 'backgroundColor': isLockedBtnSalvar ? '#ebeef5' : '', 'border-color' : isLockedBtnSalvar ? '#ebeef5' : '#00a04e'}"
          >
            <span>Solicitar</span>
          </button>
        </div>

              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </form>

    <!-- Dados de Correspondencia -->
    <form class="form_padrao pt-2" v-if="activeData == 3" id="dados-correspondencia" @keydown.tab.prevent>
      <div
          class="form-group col-12 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="button"
            class="btn btn-verde p-0 fit-content"
            @click="solicitarAlteracao"
            :style="{ 'backgroundColor': isLockedBtnSalvar ? '#ebeef5' : '', 'border-color' : isLockedBtnSalvar ? '#ebeef5' : '#00a04e'}"
          >
            <span>Solicitar</span>
          </button>
        </div>
    </form>

  </div>
  </section>

  
</template>

<script>

import axios from 'axios';
import { corrigeData } from '../../helpers';

export default {
  name: "DadosCadastrais",
  data() {
    return {
      atendimento: false,
      formularioExibir: false,
      loading: false,
      alterado: false,
      status: '',
      countCamposFormAtualizado: 0,
      activeData: 0,
      disabled: false,
      data : null,
      dismissSecs: 30,
      dismissCountDown: 0,
      isLocked: true, 
      isLockedBtnSalvar: true,
      isLockedBtnConsultar: false,
      isLockedBtnSolicitar: false,
      todosChamadosAbertos: [
      { codigo: '', dataAbertura: '', dataFechamento: '' }
      ],
      asChamadosCadastrais: false,
      campoObrigatorio: false,
      formAtual : {
                dadosCadastraisAssociado: {
                    doc:'',
                    razaosocial: '',
                    nomecomercial: '',
                    emailDadosPrincipais: '',
                    cepDadosPrincipais: '',
                    logradouroDadosPrincipais: '',
                    numeroDadosPrincipais: '',
                    ufDadosPrincipais: '',
                    complementoDadosPrincipais: '',
                    bairroDadosPrincipais: '',
                    cidadeDadosPrincipais: '',
                    inscest: '',
                    telefoneDadosCadastrais: ''
                },
                dadosContatoPrincipal: {
                    nomeContato: '',
                    emailContato: '',
                    dadosContatoCPF: '',
                    ddd: '',
                    telefone: ''
                },
                dadosEnderecoCobranca: {
                    cepCobranca: '',
                    logradouroCobranca: '',
                    numeroCobranca: '',
                    complementoCobranca: '',
                    cidadeCobranca: '',
                    ufCobranca: '',
                    bairroCobranca: ''
                },
                dadosEnderecoCorrespondencia: {
                    cepCorrespondencia: '',
                    logradouroCorrespondencia: '',
                    numeroCorrespondencia: '',
                    complementoCorrespondencia: '',
                    cidadeCorrespondencia: '',
                    ufCorrespondencia: '',
                    bairroCorrespondencia: ''
                },
        
      },
      formAtualizado: {
                dadosCadastraisAssociado: {
                    doc:'',
                    razaosocial:'',
                    nomecomercial: '',
                    emailDadosPrincipais: '',
                    cepDadosPrincipais: '',
                    logradouroDadosPrincipais: '',
                    numeroDadosPrincipais: '',
                    ufDadosPrincipais: '',
                    complementoDadosPrincipais: '',
                    bairroDadosPrincipais: '',
                    cidadeDadosPrincipais: '',
                    inscest: '',
                    telefoneDadosCadastrais: ''
                },
                dadosContatoPrincipal: {
                    nomeContato: '',
                    emailContato: '',
                    dadosContatoCPF: '',
                    ddd: '',
                    telefone: ''
                },
                dadosEnderecoCobranca: {
                    cepCobranca: '',
                    logradouroCobranca: '',
                    numeroCobranca: '',
                    complementoCobranca: '',
                    cidadeCobranca: '',
                    ufCobranca: '',
                    bairroCobranca: ''
                },
                dadosEnderecoCorrespondencia: {
                    cepCorrespondencia: '',
                    logradouroCorrespondencia: '',
                    numeroCorrespondencia: '',
                    complementoCorrespondencia: '',
                    cidadeCorrespondencia: '',
                    ufCorrespondencia: '',
                    bairroCorrespondencia: ''
                },
        
      },
    };
  },
  computed: {
    usuario: {
      get() {
        return this.$store.getters.getUsuario;
      },
      set(value) {
        this.$store.commit("UPDATE_USER", value);
      },
    }
  },
  mounted() {

        this.status = this.value;

        this.formAtual = {
                dadosCadastraisAssociado: {
                    doc:this.$store.state.userDetails.dadosCadastraisAssociado[0].doc,
                    razaosocial:this.$store.state.userDetails.dadosCadastraisAssociado[0].razaosocial,
                    nomecomercial: this.$store.state.userDetails.dadosCadastraisAssociado[0].nomecomercial,
                    emailDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].email,
                    cepDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].cep,
                    logradouroDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].lograd,
                    numeroDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].numero,
                    ufDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].uf,
                    complementoDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].complemento,
                    bairroDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].bairro,
                    cidadeDadosPrincipais: this.$store.state.userDetails.dadosCadastraisAssociado[0].cidade,
                    inscest: this.$store.state.userDetails.dadosCadastraisAssociado[0].inscest,
                    telefoneDadosCadastrais: this.$store.state.userDetails.dadosCadastraisAssociado[0].telefone

                },
                dadosContatoPrincipal: {
                    nomeContato: this.$store.state.userDetails.dadosContatoPrincipal[0].nome,
                    emailContato: this.$store.state.userDetails.dadosContatoPrincipal[0].email,
                    dadosContatoCPF: this.$store.state.userDetails.dadosContatoPrincipal[0].cpf,
                    ddd: this.$store.state.userDetails.dadosContatoPrincipal[0].ddd,
                    telefone: this.$store.state.userDetails.dadosContatoPrincipal[0].telefone,
                },
                dadosEnderecoCobranca: {
                    cepCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].cep,
                    logradouroCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].lograd,
                    numeroCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].numero,
                    complementoCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].complemento,
                    cidadeCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].cidade,
                    ufCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].uf,
                    bairroCobranca: this.$store.state.userDetails.dadosEnderecoCobranca[0].bairro,
                },
                dadosEnderecoCorrespondencia: {
                    cepCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].cep,
                    logradouroCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].lograd,
                    numeroCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].numero,
                    complementoCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].complemento,
                    cidadeCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].cidade,
                    ufCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].uf,
                    bairroCorrespondencia: this.$store.state.userDetails.dadosEnderecoCorrespondencia[0].bairro
                },
        };

        this.result = { };
      },
  methods: {
      toggle() {
        this.loading = true;
        axios.get(this.toggleUrl).then(response => {
                    this.status = response.data;
                    this.loading = false;
                })
      },
      formAtualizadoCopied() {

                 for (const key in this.formAtual) {
                    for (const data in this.formAtual[key]) {

                        for (const key2 in this.formAtualizado) {
                         
                         for (const data2 in this.formAtualizado[key2]) {

                          if(this.formAtual[key][data] === this.formAtualizado[key2][data2] && this.formAtualizado[key2][data2] !== ''){

                              this.formAtualizado[key2][data2] = '';
                             
                          }
                        }
                      }
                    }
                  }

      },
      getCountCamposFormAtualizado(){

        for (const key in this.formAtualizado) {
          for (const data in this.formAtualizado[key]) {

              if(this.formAtualizado[key][data] !== ''){
                this.countCamposFormAtualizado++;    
              }
 
          }
        }
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      buscarChamadosFluig() {
        this.dismissCountDown = this.dismissSecs;
        this.isLockedBtnConsultar = true;

        this.$http
          .post("/api/CdlBh/ConsultarChamadoDadosCadastrais", {
            CodSocio: `${this.$user.dadosCadastraisAssociado[0].codsociO_TEMP}`
          })
              
          .then((response) => {
            var dadosCadastraisAbertoArray = [];
            var dadosCadastraisFechadosArray = [];

            this.isLocked = false;
            this.isLockedBtnConsultar = false;
            this.dismissCountDown = 0;
            this.formularioExibir = true;

            response.data.forEach(function(item) {
              var dataAbertura = item.dataAbertura;
              if(dataAbertura !== ''){
                item.dataAbertura = corrigeData(item.dataAbertura);
               }

               var dataFechamentoValue = item.dataFechamento;
               if (dataFechamentoValue === '') {
                  dadosCadastraisAbertoArray.push(item);
               }
               if(dataFechamentoValue !== ''){
                 item.dataFechamentoValue = corrigeData(item.dataFechamentoValue);
                 dadosCadastraisFechadosArray.push(item);
               }
            });

            if(dadosCadastraisFechadosArray.length === 0 && dadosCadastraisAbertoArray.length === 0){
              this.isLocked = false;
              this.isLockedBtnConsultar = false;
              this.asChamadosCadastrais = false;

              this.$toast.open({
                message: "Não existem chamados em aberto. Solicitar alteração no formulário.",
                type: "warning",
                duration: 10000,
              });

              return false;
            }

            if(dadosCadastraisFechadosArray.length !== 0 && dadosCadastraisAbertoArray.length !== 0){
              this.isLocked = true;
              this.atendimento = true;
              this.isLockedBtnConsultar = false;
              this.asChamadosCadastrais = true;
              this.todosChamadosAbertos = dadosCadastraisAbertoArray.concat(dadosCadastraisFechadosArray[dadosCadastraisFechadosArray.length -1]);
              return false;
            }

            if(dadosCadastraisFechadosArray.length !== 0 && dadosCadastraisAbertoArray.length === 0){
              this.isLocked = false;
              this.atendimento = true;
              this.isLockedBtnConsultar = false;
              this.asChamadosCadastrais = true;
              this.todosChamadosAbertos = [dadosCadastraisFechadosArray[dadosCadastraisFechadosArray.length -1]];


              this.$toast.open({
                message: "Os dados já podem ser modificados.",
                type: "success",
                duration: 10000,
              });

              return false;
            }

            if(dadosCadastraisFechadosArray.length === 0 && dadosCadastraisAbertoArray.length !== 0){
              this.isLocked = true;
              this.atendimento = true;
              this.isLockedBtnConsultar = false;
              this.asChamadosCadastrais = true;
              this.todosChamadosAbertos = dadosCadastraisAbertoArray;
              return false;
            }
          })
          .catch(() => {
            console.log("error");
          });
      },
      searchCepDadosPrincipais () {

      this.usuario.dadosCadastraisAssociado[0].cep = this.usuario.dadosCadastraisAssociado[0].cep.replace(/[^\w\s]/g, '');

      if(this.usuario.dadosCadastraisAssociado[0].cep.length === 8){

        axios.get(`https://viacep.com.br/ws/${this.usuario.dadosCadastraisAssociado[0].cep}/json/`)
        .then(response => {
          
          this.usuario.dadosCadastraisAssociado[0].cep = response.data.cep;
          this.setDados('cepDadosPrincipais', response.data.cep);
          
          this.usuario.dadosCadastraisAssociado[0].lograd = response.data.logradouro;
          this.setDados('logradouroDadosPrincipais', response.data.logradouro);

          this.usuario.dadosCadastraisAssociado[0].numero = '';
          this.setDados('numeroDadosPrincipais', '');

          this.usuario.dadosCadastraisAssociado[0].complemento = response.data.complemento;
          this.setDados('complementoDadosPrincipais', response.data.complemento);

          this.usuario.dadosCadastraisAssociado[0].bairro = response.data.bairro;
          this.setDados('bairroDadosPrincipais', response.data.bairro);
        
          this.usuario.dadosCadastraisAssociado[0].cidade = response.data.localidade;
          this.setDados('cidadeDadosPrincipais', response.data.localidade);
        
          this.usuario.dadosCadastraisAssociado[0].uf = response.data.uf;
          this.setDados('ufDadosPrincipais', response.data.uf + " ");
        })
        .catch(error => {
          console.log(error);
        });
        
      }     


	  	},
      searchCepCobranca () {

      this.usuario.dadosEnderecoCobranca[0].cep = this.usuario.dadosEnderecoCobranca[0].cep.replace(/[^\w\s]/g, '');

      if(this.usuario.dadosEnderecoCobranca[0].cep.length === 8){

        axios.get(`https://viacep.com.br/ws/${this.usuario.dadosEnderecoCobranca[0].cep}/json/`)
        .then(response => {

          this.usuario.dadosEnderecoCobranca[0].cep = response.data.cep;
          this.setDadosCobranca('cepCobranca', response.data.cep);
           
          this.usuario.dadosEnderecoCobranca[0].lograd = response.data.logradouro;
          this.setDadosCobranca('logradouroCobranca', response.data.logradouro);

          this.usuario.dadosEnderecoCobranca[0].numero = '';
          this.setDadosCobranca('numeroCobranca', '');

          this.usuario.dadosEnderecoCobranca[0].complemento = response.data.complemento;
          this.setDadosCobranca('complementoCobranca', response.data.complemento);

          this.usuario.dadosEnderecoCobranca[0].cidade = response.data.localidade;
          this.setDadosCobranca('cidadeCobranca', response.data.localidade);

          this.usuario.dadosEnderecoCobranca[0].uf = response.data.uf;
          this.setDadosCobranca('ufCobranca', response.data.uf + " ");

          this.usuario.dadosEnderecoCobranca[0].bairro = response.data.bairro;
          this.setDadosCobranca('bairroCobranca', response.data.bairro);

        })
        .catch(error => {
          console.error(error);
        });
        
      }

		  },
      searchCepCorrespondencia() {

        this.usuario.dadosEnderecoCorrespondencia[0].cep = this.usuario.dadosEnderecoCorrespondencia[0].cep.replace(/[^\w\s]/g, '');

        if(this.usuario.dadosEnderecoCorrespondencia[0].cep.length === 8){

            axios.get(`https://viacep.com.br/ws/${this.usuario.dadosEnderecoCorrespondencia[0].cep}/json/`)
              .then(response => {
                
                this.usuario.dadosEnderecoCorrespondencia[0].cep = response.data.cep;
                this.setDadosCorrespondencia('cepCorrespondencia', response.data.cep);

                this.usuario.dadosEnderecoCorrespondencia[0].lograd = response.data.logradouro;
                this.setDadosCorrespondencia('logradouroCorrespondencia', response.data.logradouro);

                this.usuario.dadosEnderecoCorrespondencia[0].numero = '';
                this.setDadosCorrespondencia('numeroCorrespondencia', '');

                this.usuario.dadosEnderecoCorrespondencia[0].complemento = response.data.complemento;
                this.setDadosCorrespondencia('complementoCorrespondencia', response.data.complemento);

                this.usuario.dadosEnderecoCorrespondencia[0].cidade = response.data.localidade;
                this.setDadosCorrespondencia('cidadeCorrespondencia', response.data.localidade);

                this.usuario.dadosEnderecoCorrespondencia[0].uf = response.data.uf;
                this.setDadosCorrespondencia('ufCorrespondencia', response.data.uf + " ");

                this.usuario.dadosEnderecoCorrespondencia[0].bairro = response.data.bairro;
                this.setDadosCorrespondencia('bairroCorrespondencia', response.data.bairro);
              })
              .catch(error => {
                console.error(error);
              });
        }

      },
      setDadosContato(field, valor) {
        this.campoObrigatorio = false;
        this.isLockedBtnSalvar = false,
        this.formAtualizado.dadosContatoPrincipal[field] = valor;
        this.formAtualizadoCopied()
      },
      setDadosCobranca(field, valor) {
        this.campoObrigatorio = false;
        this.isLockedBtnSalvar = false,
        this.formAtualizado.dadosEnderecoCobranca[field] = valor;
        this.formAtualizadoCopied()
      },
      setDadosCorrespondencia(field, valor) {
        this.campoObrigatorio = false;
        this.isLockedBtnSalvar = false,
        this.formAtualizado.dadosEnderecoCorrespondencia[field] = valor;
        this.formAtualizadoCopied()
      },
      setDados(field, valor) {
        this.campoObrigatorio = false;
        this.isLockedBtnSalvar = false; 
        this.formAtualizado.dadosCadastraisAssociado[field] = valor;
        this.formAtualizadoCopied()
      },
      solicitarAlteracao() {

        this.getCountCamposFormAtualizado();


        if(this.countCamposFormAtualizado === 0){

          this.$toast.open({
                  message: "Os dados não foram modificados!",
                  type: "warning",
                  duration: 10000,
                });

        return false;
        }


      this.formAtualizado.dadosCadastraisAssociado['tipo'] = "Dados da Empresa";      
      // this.formAtualizado.dadosCadastraisAssociado['doc'] = this.$store.state.userDetails.dadosCadastraisAssociado[0].doc;
      // this.formAtualizado.dadosCadastraisAssociado['razaosocial'] = this.$store.state.userDetails.dadosCadastraisAssociado[0].razaosocial;
      this.formAtualizado.dadosContatoPrincipal['tipo'] = "Dados de Contato";
      this.formAtualizado.dadosEnderecoCobranca['tipo'] = "Endereço de Cobrança";
      this.formAtualizado.dadosEnderecoCorrespondencia['tipo'] = "Endereço de Correspondência";
     

      //Dados Alterados
      let value = {
        "CodSocio" : this.$user.dadosCadastraisAssociado[0].codsociO_TEMP,
        "DadosCadastrais" : this.formAtual.dadosCadastraisAssociado,
        "DadosContato" : this.formAtual.dadosContatoPrincipal,
        "DadosCobranca" : this.formAtual.dadosEnderecoCobranca,
        "DadosCorrespondencia" : this.formAtual.dadosEnderecoCorrespondencia,

        "DadosCadastraisAlterados" : this.formAtualizado.dadosCadastraisAssociado,
        "DadosContatoAlterados" : this.formAtualizado.dadosContatoPrincipal,
        "DadosCobrancaAlterados" : this.formAtualizado.dadosEnderecoCobranca,
        "DadosCorrespondenciaAlterados" : this.formAtualizado.dadosEnderecoCorrespondencia
      }


     

      //MOTIVO

      this.isLockedBtnSolicitar = true;
     
        this.$http
          .post("/api/CdlBh/RegistrarChamadoDadosCadastrais", value)
          .then((response) => {

            this.disabled = true;
            this.countCamposFormAtualizado = 0;
            this.isLocked = true;
            this.isLockedBtnConsultar = false;
            this.asChamadosCadastrais = false;
            this.isLockedBtnSalvar = true;

            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
              duration: 100000,
            });

            setTimeout(function() {
              window.location.reload(1);
            }, 100000); // 5 segundos

        

          })
          .catch(() => {
            this.loading = false;
            this.countCamposFormAtualizado = 0;
            
            this.$toast.open({
              message: "Erro ao realizar abertura do chamado para Dados Cadastrais.",
              type: "warning",
              duration: 10000,
            });

          });
        
      },
  },
};
</script>
<style lang="scss" scoped>
.nav-item {
  a {
    transition: all 0.2s ease-in-out;
    color: #888;
    padding: 0.7rem;
    margin: 0 0.3rem;
    font-size: 0.9rem;
    font-weight: 600;
  }
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #ffffff;
  background-color: #05438e;
  border-color: none;
  padding: 0.7rem;
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-color: transparent;
}
.form_padrao {
  .form-group.flutuante {
    position: relative;
    input[type="text"],
    input[type="password"],
    input[type="email"],
    input[type="tel"],
    textarea {
      background: white;
    }
  }
  .fit-content {
    max-width: fit-content;
    padding: 0.6rem 1rem !important;
  }
}
@media screen and(max-width: 900px) {
  .fit-content {
    max-width: 100% !important;
  }
  .alert-warning {
    font-size: 0.7rem;
  }
  .close {
    display: none;
  }
}

@media screen and (max-width: 900px) {
  .close {
    display: block;
  }
}

#dados-tab {
  overflow-y: hidden;
  white-space: nowrap;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
